module.exports = __webpack_public_path__ + "img/cutMind.8849e9e3.svg";